<template>
    <div>
        <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>
        <div class="row">
            <b-select v-model="perPage" :options="pageOptions" class="pageSizeClass" />
            <b-input 
                id="search-input" 
                class="col-md-6 col-lg-4 ml-2 mb-2 mb-sm-0" 
                :placeholder="$t('parametrics.announcementsSearchBy')"
                v-model="searchString"
            />
            <router-link :to="{name: 'announcementsAdd'}" class="ml-auto">
                <b-button class="esep-blue-bg " variant="primary">{{ $t("parametrics.addAnnouncements") }}
                </b-button>
            </router-link>
        </div>
        <b-table
            :items="announcements"
            :fields="fields"
            :filter="searchString"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :per-page="perPage"
            :current-page="currentPage"
            responsive
            show-empty
            ref="announcementsTable"
            class="mt-2"
            thead-class="esep-blue-bg text-light"
        >
            <template v-slot:cell(action)="row">
                <b-button
                    size="sm"
                    @click="editAnnouncements(row)"
                    variant="transparent"
                    :title="$t('parametrics.editAnnouncements')"
                >
                    <b-icon icon="pencil-square"/>
                </b-button>
                <b-button
                    size="sm"
                    @click="showWithdrawTemplate(row.item)"
                    variant="transparent"
                    v-b-tooltip.hover
                    :title="$t('parametrics.deleteTemplate')"
                    >
                    <b-icon icon="trash" />
                </b-button>
            </template>

            <template v-slot:empty="">
                <h6>{{ $t("parametrics.emptyAnnouncementsTable") }}</h6>
            </template>
        </b-table>
        <b-row>
            <b-col>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                align="right"
                aria-controls="members-table"
                variant="info"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
    computed: {
        rows() {
            return this.filteredItems ? this.filteredItems.length : this.announcements ? this.announcements.length : 0;
        }
    },
    props: {
        announcements: Array
    },
    data() {
        return{
            successMessage: null,
            popSuccessAlert: false,
            perPage: 10,
            currentPage: 1,
            pageOptions: [
                10,
                20,
                50,
                {
                    value: Number.MAX_SAFE_INTEGER,
                    text: "All",
                },
            ],
            sortBy: "title",
            sortDesc: false,
            fields: [
                { key: "id", label: "Κωδικός", sortable: true},
                { key: "title", label: "Τίτλος Προτύπου", sortable: true },
                { key: "action", label: "Ενέργεια", sortable: false  }
            ],
            filterOn: ["title", "id"],
            searchString: "",
            filteredItems: null
        }
    },
    methods: {
        editAnnouncements(row) {
            this.$log.debug(row);
            this.$router.push({name: 'announcementsEdit',params: { id: row.item.id }});
        },
        onFiltered(filteredItems) {
            if (this.rows !== filteredItems.length) {
                this.filteredItems = filteredItems;
                this.currentPage = 1
            } else {
                this.filteredItems = null
            }
        },
        showWithdrawTemplate(template) {
            this.$emit('show-withdraw-template', template);
        }
        
    }
}
</script>